module.exports = __webpack_public_path__ + "img/垂钓.b272674f.webp";